function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module link/linkediting
 */
import { Plugin } from 'ckeditor5/src/core';
import { MouseObserver } from 'ckeditor5/src/engine';
import { Input, TwoStepCaretMovement, inlineHighlight, findAttributeRange } from 'ckeditor5/src/typing';
import { ClipboardPipeline } from 'ckeditor5/src/clipboard';
import { keyCodes } from 'ckeditor5/src/utils';
import LinkCommand from './linkcommand';
import UnlinkCommand from './unlinkcommand';
import ManualDecorator from './utils/manualdecorator';
import { createLinkElement, ensureSafeUrl, getLocalizedDecorators, normalizeDecorators } from './utils';
import '../theme/link.css';
var HIGHLIGHT_CLASS = 'ck-link_selected';
var DECORATOR_AUTOMATIC = 'automatic';
var DECORATOR_MANUAL = 'manual';
var EXTERNAL_LINKS_REGEXP = /^(https?:)?\/\//;
/**
 * The link engine feature.
 *
 * It introduces the `linkHref="url"` attribute in the model which renders to the view as a `<a href="url">` element
 * as well as `'link'` and `'unlink'` commands.
 *
 * @extends module:core/plugin~Plugin
 */

var LinkEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(LinkEditing, _Plugin);

  var _super = _createSuper(LinkEditing);

  /**
   * @inheritDoc
   */
  function LinkEditing(editor) {
    var _this;

    _classCallCheck(this, LinkEditing);

    _this = _super.call(this, editor);
    editor.config.define('link', {
      addTargetToExternalLinks: false
    });
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(LinkEditing, [{
    key: "init",
    value: function init() {
      var editor = this.editor; // Allow link attribute on all inline nodes.

      editor.model.schema.extend('$text', {
        allowAttributes: 'linkHref'
      });
      editor.conversion.for('dataDowncast').attributeToElement({
        model: 'linkHref',
        view: createLinkElement
      });
      editor.conversion.for('editingDowncast').attributeToElement({
        model: 'linkHref',
        view: function view(href, conversionApi) {
          return createLinkElement(ensureSafeUrl(href), conversionApi);
        }
      });
      editor.conversion.for('upcast').elementToAttribute({
        view: {
          name: 'a',
          attributes: {
            href: true
          }
        },
        model: {
          key: 'linkHref',
          value: function value(viewElement) {
            return viewElement.getAttribute('href');
          }
        }
      }); // Create linking commands.

      editor.commands.add('link', new LinkCommand(editor));
      editor.commands.add('unlink', new UnlinkCommand(editor));
      var linkDecorators = getLocalizedDecorators(editor.t, normalizeDecorators(editor.config.get('link.decorators')));

      this._enableAutomaticDecorators(linkDecorators.filter(function (item) {
        return item.mode === DECORATOR_AUTOMATIC;
      }));

      this._enableManualDecorators(linkDecorators.filter(function (item) {
        return item.mode === DECORATOR_MANUAL;
      })); // Enable two-step caret movement for `linkHref` attribute.


      var twoStepCaretMovementPlugin = editor.plugins.get(TwoStepCaretMovement);
      twoStepCaretMovementPlugin.registerAttribute('linkHref'); // Setup highlight over selected link.

      inlineHighlight(editor, 'linkHref', 'a', HIGHLIGHT_CLASS); // Change the attributes of the selection in certain situations after the link was inserted into the document.

      this._enableInsertContentSelectionAttributesFixer(); // Handle a click at the beginning/end of a link element.


      this._enableClickingAfterLink(); // Handle typing over the link.


      this._enableTypingOverLink(); // Handle removing the content after the link element.


      this._handleDeleteContentAfterLink();
    }
    /**
     * Processes an array of configured {@link module:link/link~LinkDecoratorAutomaticDefinition automatic decorators}
     * and registers a {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher downcast dispatcher}
     * for each one of them. Downcast dispatchers are obtained using the
     * {@link module:link/utils~AutomaticDecorators#getDispatcher} method.
     *
     * **Note**: This method also activates the automatic external link decorator if enabled with
     * {@link module:link/link~LinkConfig#addTargetToExternalLinks `config.link.addTargetToExternalLinks`}.
     *
     * @private
     * @param {Array.<module:link/link~LinkDecoratorAutomaticDefinition>} automaticDecoratorDefinitions
     */

  }, {
    key: "_enableAutomaticDecorators",
    value: function _enableAutomaticDecorators(automaticDecoratorDefinitions) {
      var editor = this.editor; // Store automatic decorators in the command instance as we do the same with manual decorators.
      // Thanks to that, `LinkImageEditing` plugin can re-use the same definitions.

      var command = editor.commands.get('link');
      var automaticDecorators = command.automaticDecorators; // Adds a default decorator for external links.

      if (editor.config.get('link.addTargetToExternalLinks')) {
        automaticDecorators.add({
          id: 'linkIsExternal',
          mode: DECORATOR_AUTOMATIC,
          callback: function callback(url) {
            return EXTERNAL_LINKS_REGEXP.test(url);
          },
          attributes: {
            target: '_blank',
            rel: 'noopener noreferrer'
          }
        });
      }

      automaticDecorators.add(automaticDecoratorDefinitions);

      if (automaticDecorators.length) {
        editor.conversion.for('downcast').add(automaticDecorators.getDispatcher());
      }
    }
    /**
     * Processes an array of configured {@link module:link/link~LinkDecoratorManualDefinition manual decorators},
     * transforms them into {@link module:link/utils~ManualDecorator} instances and stores them in the
     * {@link module:link/linkcommand~LinkCommand#manualDecorators} collection (a model for manual decorators state).
     *
     * Also registers an {@link module:engine/conversion/downcasthelpers~DowncastHelpers#attributeToElement attribute-to-element}
     * converter for each manual decorator and extends the {@link module:engine/model/schema~Schema model's schema}
     * with adequate model attributes.
     *
     * @private
     * @param {Array.<module:link/link~LinkDecoratorManualDefinition>} manualDecoratorDefinitions
     */

  }, {
    key: "_enableManualDecorators",
    value: function _enableManualDecorators(manualDecoratorDefinitions) {
      if (!manualDecoratorDefinitions.length) {
        return;
      }

      var editor = this.editor;
      var command = editor.commands.get('link');
      var manualDecorators = command.manualDecorators;
      manualDecoratorDefinitions.forEach(function (decorator) {
        editor.model.schema.extend('$text', {
          allowAttributes: decorator.id
        }); // Keeps reference to manual decorator to decode its name to attributes during downcast.

        manualDecorators.add(new ManualDecorator(decorator));
        editor.conversion.for('downcast').attributeToElement({
          model: decorator.id,
          view: function view(manualDecoratorName, _ref) {
            var writer = _ref.writer;

            if (manualDecoratorName) {
              var attributes = manualDecorators.get(decorator.id).attributes;
              var element = writer.createAttributeElement('a', attributes, {
                priority: 5
              });
              writer.setCustomProperty('link', true, element);
              return element;
            }
          }
        });
        editor.conversion.for('upcast').elementToAttribute({
          view: {
            name: 'a',
            attributes: manualDecorators.get(decorator.id).attributes
          },
          model: {
            key: decorator.id
          }
        });
      });
    }
    /**
     * Starts listening to {@link module:engine/model/model~Model#event:insertContent} and corrects the model
     * selection attributes if the selection is at the end of a link after inserting the content.
     *
     * The purpose of this action is to improve the overall UX because the user is no longer "trapped" by the
     * `linkHref` attribute of the selection and they can type a "clean" (`linkHref`–less) text right away.
     *
     * See https://github.com/ckeditor/ckeditor5/issues/6053.
     *
     * @private
     */

  }, {
    key: "_enableInsertContentSelectionAttributesFixer",
    value: function _enableInsertContentSelectionAttributesFixer() {
      var editor = this.editor;
      var model = editor.model;
      var selection = model.document.selection;
      this.listenTo(model, 'insertContent', function () {
        var nodeBefore = selection.anchor.nodeBefore;
        var nodeAfter = selection.anchor.nodeAfter; // NOTE: ↰ and ↱ represent the gravity of the selection.
        // The only truly valid case is:
        //
        //		                                 ↰
        //		...<$text linkHref="foo">INSERTED[]</$text>
        //
        // If the selection is not "trapped" by the `linkHref` attribute after inserting, there's nothing
        // to fix there.

        if (!selection.hasAttribute('linkHref')) {
          return;
        } // Filter out the following case where a link with the same href (e.g. <a href="foo">INSERTED</a>) is inserted
        // in the middle of an existing link:
        //
        // Before insertion:
        //		                       ↰
        //		<$text linkHref="foo">l[]ink</$text>
        //
        // Expected after insertion:
        //		                               ↰
        //		<$text linkHref="foo">lINSERTED[]ink</$text>
        //


        if (!nodeBefore) {
          return;
        } // Filter out the following case where the selection has the "linkHref" attribute because the
        // gravity is overridden and some text with another attribute (e.g. <b>INSERTED</b>) is inserted:
        //
        // Before insertion:
        //
        //		                       ↱
        //		<$text linkHref="foo">[]link</$text>
        //
        // Expected after insertion:
        //
        //		                                                          ↱
        //		<$text bold="true">INSERTED</$text><$text linkHref="foo">[]link</$text>
        //


        if (!nodeBefore.hasAttribute('linkHref')) {
          return;
        } // Filter out the following case where a link is a inserted in the middle (or before) another link
        // (different URLs, so they will not merge). In this (let's say weird) case, we can leave the selection
        // attributes as they are because the user will end up writing in one link or another anyway.
        //
        // Before insertion:
        //
        //		                       ↰
        //		<$text linkHref="foo">l[]ink</$text>
        //
        // Expected after insertion:
        //
        //		                                                             ↰
        //		<$text linkHref="foo">l</$text><$text linkHref="bar">INSERTED[]</$text><$text linkHref="foo">ink</$text>
        //


        if (nodeAfter && nodeAfter.hasAttribute('linkHref')) {
          return;
        }

        model.change(function (writer) {
          removeLinkAttributesFromSelection(writer, getLinkAttributesAllowedOnText(model.schema));
        });
      }, {
        priority: 'low'
      });
    }
    /**
     * Starts listening to {@link module:engine/view/document~Document#event:mousedown} and
     * {@link module:engine/view/document~Document#event:selectionChange} and puts the selection before/after a link node
     * if clicked at the beginning/ending of the link.
     *
     * The purpose of this action is to allow typing around the link node directly after a click.
     *
     * See https://github.com/ckeditor/ckeditor5/issues/1016.
     *
     * @private
     */

  }, {
    key: "_enableClickingAfterLink",
    value: function _enableClickingAfterLink() {
      var editor = this.editor;
      var model = editor.model;
      editor.editing.view.addObserver(MouseObserver);
      var clicked = false; // Detect the click.

      this.listenTo(editor.editing.view.document, 'mousedown', function () {
        clicked = true;
      }); // When the selection has changed...

      this.listenTo(editor.editing.view.document, 'selectionChange', function () {
        if (!clicked) {
          return;
        } // ...and it was caused by the click...


        clicked = false;
        var selection = model.document.selection; // ...and no text is selected...

        if (!selection.isCollapsed) {
          return;
        } // ...and clicked text is the link...


        if (!selection.hasAttribute('linkHref')) {
          return;
        }

        var position = selection.getFirstPosition();
        var linkRange = findAttributeRange(position, 'linkHref', selection.getAttribute('linkHref'), model); // ...check whether clicked start/end boundary of the link.
        // If so, remove the `linkHref` attribute.

        if (position.isTouching(linkRange.start) || position.isTouching(linkRange.end)) {
          model.change(function (writer) {
            removeLinkAttributesFromSelection(writer, getLinkAttributesAllowedOnText(model.schema));
          });
        }
      });
    }
    /**
     * Starts listening to {@link module:engine/model/model~Model#deleteContent} and {@link module:engine/model/model~Model#insertContent}
     * and checks whether typing over the link. If so, attributes of removed text are preserved and applied to the inserted text.
     *
     * The purpose of this action is to allow modifying a text without loosing the `linkHref` attribute (and other).
     *
     * See https://github.com/ckeditor/ckeditor5/issues/4762.
     *
     * @private
     */

  }, {
    key: "_enableTypingOverLink",
    value: function _enableTypingOverLink() {
      var editor = this.editor;
      var view = editor.editing.view; // Selection attributes when started typing over the link.

      var selectionAttributes; // Whether pressed `Backspace` or `Delete`. If so, attributes should not be preserved.

      var deletedContent; // Detect pressing `Backspace` / `Delete`.

      this.listenTo(view.document, 'delete', function () {
        deletedContent = true;
      }, {
        priority: 'high'
      }); // Listening to `model#deleteContent` allows detecting whether selected content was a link.
      // If so, before removing the element, we will copy its attributes.

      this.listenTo(editor.model, 'deleteContent', function () {
        var selection = editor.model.document.selection; // Copy attributes only if anything is selected.

        if (selection.isCollapsed) {
          return;
        } // When the content was deleted, do not preserve attributes.


        if (deletedContent) {
          deletedContent = false;
          return;
        } // Enabled only when typing.


        if (!isTyping(editor)) {
          return;
        }

        if (shouldCopyAttributes(editor.model)) {
          selectionAttributes = selection.getAttributes();
        }
      }, {
        priority: 'high'
      }); // Listening to `model#insertContent` allows detecting the content insertion.
      // We want to apply attributes that were removed while typing over the link.

      this.listenTo(editor.model, 'insertContent', function (evt, _ref2) {
        var _ref3 = _slicedToArray(_ref2, 1),
            element = _ref3[0];

        deletedContent = false; // Enabled only when typing.

        if (!isTyping(editor)) {
          return;
        }

        if (!selectionAttributes) {
          return;
        }

        editor.model.change(function (writer) {
          var _iterator = _createForOfIteratorHelper(selectionAttributes),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _ref6 = _step.value;

              var _ref5 = _slicedToArray(_ref6, 2);

              var attribute = _ref5[0];
              var value = _ref5[1];
              writer.setAttribute(attribute, value, element);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        });
        selectionAttributes = null;
      }, {
        priority: 'high'
      });
    }
    /**
     * Starts listening to {@link module:engine/model/model~Model#deleteContent} and checks whether
     * removing a content right after the "linkHref" attribute.
     *
     * If so, the selection should not preserve the `linkHref` attribute. However, if
     * the {@link module:typing/twostepcaretmovement~TwoStepCaretMovement} plugin is active and
     * the selection has the "linkHref" attribute due to overriden gravity (at the end), the `linkHref` attribute should stay untouched.
     *
     * The purpose of this action is to allow removing the link text and keep the selection outside the link.
     *
     * See https://github.com/ckeditor/ckeditor5/issues/7521.
     *
     * @private
     */

  }, {
    key: "_handleDeleteContentAfterLink",
    value: function _handleDeleteContentAfterLink() {
      var editor = this.editor;
      var model = editor.model;
      var selection = model.document.selection;
      var view = editor.editing.view; // A flag whether attributes `linkHref` attribute should be preserved.

      var shouldPreserveAttributes = false; // A flag whether the `Backspace` key was pressed.

      var hasBackspacePressed = false; // Detect pressing `Backspace`.

      this.listenTo(view.document, 'delete', function (evt, data) {
        hasBackspacePressed = data.domEvent.keyCode === keyCodes.backspace;
      }, {
        priority: 'high'
      }); // Before removing the content, check whether the selection is inside a link or at the end of link but with 2-SCM enabled.
      // If so, we want to preserve link attributes.

      this.listenTo(model, 'deleteContent', function () {
        // Reset the state.
        shouldPreserveAttributes = false;
        var position = selection.getFirstPosition();
        var linkHref = selection.getAttribute('linkHref');

        if (!linkHref) {
          return;
        }

        var linkRange = findAttributeRange(position, 'linkHref', linkHref, model); // Preserve `linkHref` attribute if the selection is in the middle of the link or
        // the selection is at the end of the link and 2-SCM is activated.

        shouldPreserveAttributes = linkRange.containsPosition(position) || linkRange.end.isEqual(position);
      }, {
        priority: 'high'
      }); // After removing the content, check whether the current selection should preserve the `linkHref` attribute.

      this.listenTo(model, 'deleteContent', function () {
        // If didn't press `Backspace`.
        if (!hasBackspacePressed) {
          return;
        }

        hasBackspacePressed = false; // Disable the mechanism if inside a link (`<$text url="foo">F[]oo</$text>` or <$text url="foo">Foo[]</$text>`).

        if (shouldPreserveAttributes) {
          return;
        } // Use `model.enqueueChange()` in order to execute the callback at the end of the changes process.


        editor.model.enqueueChange(function (writer) {
          removeLinkAttributesFromSelection(writer, getLinkAttributesAllowedOnText(model.schema));
        });
      }, {
        priority: 'low'
      });
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'LinkEditing';
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "requires",
    get: function get() {
      // Clipboard is required for handling cut and paste events while typing over the link.
      return [TwoStepCaretMovement, Input, ClipboardPipeline];
    }
  }]);

  return LinkEditing;
}(Plugin); // Make the selection free of link-related model attributes.
// All link-related model attributes start with "link". That includes not only "linkHref"
// but also all decorator attributes (they have dynamic names), or even custom plugins.
//
// @param {module:engine/model/writer~Writer} writer
// @param {Array.<String>} linkAttributes


export { LinkEditing as default };

function removeLinkAttributesFromSelection(writer, linkAttributes) {
  writer.removeSelectionAttribute('linkHref');

  var _iterator2 = _createForOfIteratorHelper(linkAttributes),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var attribute = _step2.value;
      writer.removeSelectionAttribute(attribute);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
} // Checks whether selection's attributes should be copied to the new inserted text.
//
// @param {module:engine/model/model~Model} model
// @returns {Boolean}


function shouldCopyAttributes(model) {
  var selection = model.document.selection;
  var firstPosition = selection.getFirstPosition();
  var lastPosition = selection.getLastPosition();
  var nodeAtFirstPosition = firstPosition.nodeAfter; // The text link node does not exist...

  if (!nodeAtFirstPosition) {
    return false;
  } // ...or it isn't the text node...


  if (!nodeAtFirstPosition.is('$text')) {
    return false;
  } // ...or isn't the link.


  if (!nodeAtFirstPosition.hasAttribute('linkHref')) {
    return false;
  } // `textNode` = the position is inside the link element.
  // `nodeBefore` = the position is at the end of the link element.


  var nodeAtLastPosition = lastPosition.textNode || lastPosition.nodeBefore; // If both references the same node selection contains a single text node.

  if (nodeAtFirstPosition === nodeAtLastPosition) {
    return true;
  } // If nodes are not equal, maybe the link nodes has defined additional attributes inside.
  // First, we need to find the entire link range.


  var linkRange = findAttributeRange(firstPosition, 'linkHref', nodeAtFirstPosition.getAttribute('linkHref'), model); // Then we can check whether selected range is inside the found link range. If so, attributes should be preserved.

  return linkRange.containsRange(model.createRange(firstPosition, lastPosition), true);
} // Checks whether provided changes were caused by typing.
//
// @params {module:core/editor/editor~Editor} editor
// @returns {Boolean}


function isTyping(editor) {
  var input = editor.plugins.get('Input');
  return input.isInput(editor.model.change(function (writer) {
    return writer.batch;
  }));
} // Returns an array containing names of attributes allowed on `$text` that describes the link item.
//
// @param {module:engine/model/schema~Schema} schema
// @returns {Array.<String>}


function getLinkAttributesAllowedOnText(schema) {
  var textAttributes = schema.getDefinition('$text').allowAttributes;
  return textAttributes.filter(function (attribute) {
    return attribute.startsWith('link');
  });
}